import { render, staticRenderFns } from "./NewsletterHorizontal.vue?vue&type=template&id=493b4e3f&scoped=true"
import script from "./NewsletterHorizontal.vue?vue&type=script&lang=js"
export * from "./NewsletterHorizontal.vue?vue&type=script&lang=js"
import style0 from "./NewsletterHorizontal.vue?vue&type=style&index=0&id=493b4e3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493b4e3f",
  null
  
)

export default component.exports